import React from 'react';
import './LegendaNumVol.css';

// La funzione getColorStyleForNumVol sarà passata come prop.

interface LegendComponentProps {
  getColorStyleForNumVol: (value: number) => string; // Modificato per aspettarsi una stringa (colore CSS)
}

const LegendComponent: React.FC<LegendComponentProps> = ({ getColorStyleForNumVol }) => {
  const legendItems = [
    { label: '1', value: 1 },
    { label: '2', value: 2 },
    { label: '3', value: 3 },
    { label: '4', value: 4 },
    { label: '5', value: 5 },
    { label: '6+', value: 6 }, // value 6 rappresenta 6+
  ];

  return (
    <div className="legendBarContainer"> {/* Contenitore per posizionamento assoluto */}
      <div className="legendBar">
        <span className="legendTitle"># Vol:</span>
        <div className="legendItemsContainer">
          {legendItems.map(item => (
            <div
              key={item.label}
              className="legendItem"
              style={{ backgroundColor: getColorStyleForNumVol(item.value) }}
            >
              {item.label}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LegendComponent; 